import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignInModalService {
  signInModal$ = new Subject<void>();

  currentUrl = '';
  portalLink = '';

  isRedirect = false;

  showModal(isRedirect = false, currentUrl = '', portalLink = ''): void {
    this.currentUrl = currentUrl || `${window.location.href}`;
    this.isRedirect = isRedirect;
    this.portalLink = portalLink;
    this.signInModal$.next();
  }
}
